import * as APIHelper from "services/api"
import * as endPoint from "shared/constants/endpoint"
import ComponentItem from "shared/models/component-item"
import { isItemBOM, transformObjectKeys } from "utils/app-helper"

class BillOfMaterialBusiness {
  getData = async searchParams => {
    const options = { params: searchParams }
    const response = (await APIHelper.getRequest(`${endPoint.bom.search}`, options)) || {}
    return response?.resource || []
  }

  getBomDetails = async params => {
    const options = { params }
    const response = await APIHelper.getRequest(`${endPoint.bom.getDetail}`, options)
    return response.resource && response.resource.length > 0 && response.resource[0].details ? transformObjectKeys(response.resource[0].details, false) : response.resource
  }

  getDetailData = async params => {
    const options = { params }
    const response = await APIHelper.getRequest(`${endPoint.bom.getDetail}`, options)
    return response.resource && response.resource.length > 0 ? response.resource[0] : response.resource
  }

  headerMapping = (sourceFields, userName, company, isEditing = false) => {
    let itemPayload = {
      ...sourceFields,
      user_stamp: userName,
      date_time_stamp: new Date(),
    }
    if (!isEditing) {
      itemPayload = {
        ...itemPayload,
        active: "Y",
        item_class: "eStore",
        company: company,
        revision_num: 1,
      }
    }
    return itemPayload
  }

  componentsNewDelete = (components, deletedComponents, oldComponents) => {
    const list = []

    const componentsNew = components.filter(item => item.action === "NEW")

    if (componentsNew) {
      componentsNew.forEach((element, idx) => {
        const existComponent = oldComponents ? oldComponents.find(item => item.build_sequence === element.build_sequence) : null

        const item = new ComponentItem(element, existComponent ? "CHANGE" : "NEW")
        if (existComponent && existComponent.internal_bom_detail_num) item.INTERNAL_BOM_DETAIL_NUM = existComponent.internal_bom_detail_num
        list.push(item)
      })
    }

    if (deletedComponents) {
      deletedComponents.forEach(element => {
        const existComponent = componentsNew ? componentsNew.find(item => item.build_sequence === element.build_sequence) : null
        if (!existComponent) {
          const item = new ComponentItem(element, "DELETE")
          list.push(item)
        }
      })
    }

    return list
  }

  componentsChange = (components, oldComponents) => {
    const list = []
    const componentsChanged = components.filter(item => item.action === "CHANGE")
    if (!componentsChanged) {
      return list
    }

    componentsChanged.forEach((element, idx) => {
      const oldProduct = oldComponents.find(item => item.internal_bom_detail_num === element.internal_bom_detail_num)

      if (oldProduct && element.build_sequence === oldProduct.build_sequence) {
        const item = new ComponentItem(element, "CHANGE")
        list.push(item)
      } else {
        if (oldProduct) {
          const itemDelete = new ComponentItem(oldProduct, "DELETE")
          list.push(itemDelete)
        }

        const itemNew = new ComponentItem(element, "NEW")
        list.push(itemNew)
      }
    })

    return list
  }

  addData = async (data, userName, company) => {
    if (!isItemBOM(data.item)) {
    }
    const addPayload = this.headerMapping(data, userName, company)

    const componentsNew = this.componentsNewDelete(data.products)

    addPayload.details = componentsNew
    delete addPayload.products
    const payload = { resource: [addPayload] }

    const response = await APIHelper.postRequest(`${endPoint.bom.post}`, payload)
    return response
  }

  updateData = async (data, userName, company) => {
    const itemPayload = this.headerMapping(data, userName, company, true)
    itemPayload.INTERNAL_BOM_HEADER_NUM = data.id

    const deletedComponents = data.products?.filter(x => x.action == "DELETE")
    const componentsNewDelete = this.componentsNewDelete(data.products, deletedComponents, data.details)
    const componentsChange = this.componentsChange(data.products, data.details)

    itemPayload.details = [...componentsChange, ...componentsNewDelete]
    delete itemPayload.products
    const payload = { resource: [itemPayload] }

    const response = await APIHelper.patchRequest(`${endPoint.bom.put}`, payload)
    return response
  }
}

export const billOfMaterialBusiness = new BillOfMaterialBusiness()
